import styled from 'styled-components'
import { white, yellowDarker } from '@bufferapp/ui/style/colors'
import { borderRadius } from '@bufferapp/ui/style/borders'

export const StyledIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledTagWrapper = styled.button<{
  $disabled?: boolean
}>`
  color: white;
  display: flex;
  padding: 4px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: ${borderRadius};
  border: none;
  cursor: pointer;
  margin-left: 4px;

  ${({ $disabled }): string | false | undefined =>
    $disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
  `}
`

export const ValidationWarningWrapper = styled.div`
  position: absolute;
  top: -6px;
  left: -4px;
  background: ${white};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    transform: scale(1.15);
  }
`
export const ValidationWarningIcon = styled.div`
  color: ${yellowDarker};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const VideoTag = styled.span`
  position: absolute;
  left: 8px;
  bottom: 8px;

  box-sizing: border-box;
  width: 24px;
  height: 24px;
  padding: 0 4px;
  color: ${white};
  border-radius: 50%;
  background-color: rgb(245 245 245 / 38%);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 12px;
    height: 12px;
  }
`

export const ThumbnailOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0.239, 0.239, 0.239, 0.15);
`
